<template>
  <div class="vload">
    <h1> {{$t('message.Load_txt')}}</h1>
    <img src="@/assets/images/spinner.gif"/>
  </div>
</template>

<script>
export default {
  name: 'vload',
  props: ['init'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadView.vue